export const TEAM_NAME_SUGGESTIONS = [
  'Avalanche',
  'Barracudas',
  'Bears',
  'Blackbirds',
  'Blazers',
  'Blizzards',
  'Bobcats',
  'Bolts',
  'Brawlers',
  'Breakers',
  'Bruins',
  'Bulldogs',
  'Bulls',
  'Buzz',
  'Cannonballs',
  'Chargers',
  'Cobras',
  'Comets',
  'Condors',
  'Cougars',
  'Cyclones',
  'Dragons',
  'Dynamo',
  'Eagles',
  'Falcons',
  'Firebirds',
  'Firestorm',
  'Foxes',
  'Frost',
  'Glaciers',
  'Griffins',
  'Grizzlies',
  'Guardians',
  'Hammerheads',
  'Hawks',
  'Heatwave',
  'Highlanders',
  'Hornets',
  'Hurricanes',
  'Icebreakers',
  'Inferno',
  'Jackals',
  'Jets',
  'Kodiaks',
  'Kraken',
  'Lancers',
  'Lightning',
  'Lions',
  'Lynx',
  'Mammoths',
  'Marlins',
  'Mavericks',
  'Meteors',
  'Monarchs',
  'Monsoons',
  'Mustangs',
  'Nightfall',
  'Orcas',
  'Outlaws',
  'Panthers',
  'Pioneers',
  'Piranhas',
  'Polar Bears',
  'Prowlers',
  'Raptors',
  'Ravens',
  'Rhinos',
  'Riverhawks',
  'Roadrunners',
  'Sabercats',
  'Scorpions',
  'Seawolves',
  'Sharks',
  'Snowdrift',
  'Spartans',
  'Stallions',
  'Stampede',
  'Stingrays',
  'Storm',
  'Strikers',
  'Surge',
  'Thunder',
  'Thunderbirds',
  'Tidal Wave',
  'Tigers',
  'Timberwolves',
  'Titans',
  'Tornadoes',
  'Trailblazers',
  'Tsunami',
  'Valkyries',
  'Vipers',
  'Voyagers',
  'Warriors',
  'Wildcats',
  'Wildfire',
  'Wolves',
] satisfies readonly string[];

const TEAM_NAME_MODIFIERS = [
  'Arctic',
  'Blue',
  'Bold',
  'Capital',
  'Coastal',
  'Crimson',
  'Desert',
  'Diamond',
  'Electric',
  'Emerald',
  'Frozen',
  'Golden',
  'Iron',
  'Midnight',
  'Mountain',
  'Northern',
  'Prairie',
  'Rapid',
  'Royal',
  'Silver',
  'Solar',
  'Southern',
  'Steel',
  'Valley',
  'Wild',
] satisfies readonly string[];

type GetRandomTeamNameSuggestionsInput = {
  count: number;
  existingNames?: readonly string[];
};

export function getRandomTeamNameSuggestions({
  count,
  existingNames = [],
}: GetRandomTeamNameSuggestionsInput) {
  const targetCount = Math.max(0, count);
  const usedNames = new Set(
    existingNames
      .map((teamName) => normalizeTeamName(teamName))
      .filter((teamName) => teamName.length > 0),
  );
  const suggestions: string[] = [];

  for (const teamName of getShuffledTeamNames(getTeamNameCandidates())) {
    if (suggestions.length >= targetCount) {
      break;
    }

    const normalizedName = normalizeTeamName(teamName);
    if (usedNames.has(normalizedName)) {
      continue;
    }

    usedNames.add(normalizedName);
    suggestions.push(teamName);
  }

  return suggestions;
}

function getTeamNameCandidates() {
  const teamNames = [...TEAM_NAME_SUGGESTIONS];

  for (const modifier of TEAM_NAME_MODIFIERS) {
    for (const teamName of TEAM_NAME_SUGGESTIONS) {
      teamNames.push(`${modifier} ${teamName}`);
    }
  }

  return teamNames;
}

function getShuffledTeamNames(teamNames: readonly string[]) {
  const shuffledNames = [...teamNames];

  for (let index = shuffledNames.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(Math.random() * (index + 1));
    const teamName = shuffledNames[index];
    const swapTeamName = shuffledNames[swapIndex];

    if (teamName === undefined || swapTeamName === undefined) {
      continue;
    }

    shuffledNames[index] = swapTeamName;
    shuffledNames[swapIndex] = teamName;
  }

  return shuffledNames;
}

function normalizeTeamName(teamName: string) {
  return teamName.trim().toLocaleLowerCase();
}
